import { APIData, appFetch } from ".";

export interface Branch {
  id: number;
  name: string;
  address: string;
  email: string;
  phone: string;
  x_axis_percent: string;
  y_axis_percent: string;
  latitude: number | null;
  longitude: number | null;
  location_url: string;
  created_at: string;
}

export const branchesAPI = {
  fetchPage(page: number) {
    return appFetch<APIData<Branch[]>>("/branches?page=" + page)
  },
};
